function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "3ccf89fc-b235-48c4-a7b3-ec74ccda02b2",
  x1: 727.96,
  y1: 757.2,
  x2: 727.96,
  y2: 618.07,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "3d0c0a2e-ebd5-4792-8384-d506b1409550",
  x1: 463.13,
  y1: 554.16,
  x2: 463.13,
  y2: 196.77,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "cfc67d4e-9240-408d-ae53-2d0cbcb1d112",
  x1: 615.25,
  y1: 738.75,
  x2: 615.25,
  y2: 213.88,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "55618a58-b994-4cf3-bc33-e350414592a2",
  x1: 137.3,
  y1: 442.59,
  x2: 137.3,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "a62bac33-b4e8-4f63-988d-f7345c8676e6",
  x1: 181.03,
  y1: 442.59,
  x2: 181.03,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "01b0c20f-63c0-4fa3-acca-bb5f9cdc7d47",
  x1: 56.57,
  y1: 442.59,
  x2: 56.57,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "e792799f-2a16-4b5c-8db0-cb1aa0d2a23d",
  x1: 113.76,
  y1: 404.47,
  x2: 113.76,
  y2: 374.19,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "4900b58d-8dde-4024-9730-e3dd5ba623cc",
  x1: 202.9,
  y1: 410.64,
  x2: 202.9,
  y2: 380.36,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "8c5be7c8-2b17-4a1f-8c6e-c3983b864ee6",
  x1: 181.03,
  y1: 397.18,
  x2: 181.03,
  y2: 366.91,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "d5b7eefc-9f3e-4b39-92f9-ccf9139cee39",
  x1: 191.69,
  y1: 429.14,
  x2: 191.69,
  y2: 398.86,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "c31766a7-9c9c-44b4-8ede-5888174e1f8a",
  x1: 152.44,
  y1: 404.47,
  x2: 152.44,
  y2: 374.19,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "4348c26f-db85-4738-947f-fb5f7cbdce4b",
  x1: 150.76,
  y1: 361.86,
  x2: 150.76,
  y2: 331.59,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "66a2fc62-0231-470f-8d66-10fd6d934ae3",
  x1: 225.32,
  y1: 383.73,
  x2: 225.32,
  y2: 353.45,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "da71f962-9307-4dc4-b5fe-1d8a8f7784ac",
  x1: 218.04,
  y1: 412.32,
  x2: 218.04,
  y2: 382.04,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "1ef09f19-b93e-4b1d-bf2c-735162991b2b",
  x1: 251.67,
  y1: 406.71,
  x2: 251.67,
  y2: 376.44,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "5c1ea6b8-5bc0-4af9-a2e3-6a873526abd3",
  x1: 236.54,
  y1: 420.73,
  x2: 236.54,
  y2: 390.45,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "30840ded-278f-4d73-abee-5ec61025ef00",
  x1: 135.62,
  y1: 383.73,
  x2: 135.62,
  y2: 353.45,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "640daeec-fe0d-4cc5-bfb0-7d2502bda475",
  x1: 113.76,
  y1: 440.91,
  x2: 113.76,
  y2: 410.64,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "9ac0ede8-18c8-48c9-b5a7-91d4c442db44",
  x1: 79.56,
  y1: 442.59,
  x2: 79.56,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "9b6ad9db-95ba-4532-a5ad-4f7024867a5b",
  x1: 96.94,
  y1: 433.06,
  x2: 96.94,
  y2: 402.79,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "8d86ace4-e95e-473e-bb5a-5a267cbf00d9",
  x1: 170.94,
  y1: 416.24,
  x2: 170.94,
  y2: 385.97,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "90785fb7-aff9-4894-accc-b6020db5a58e",
  x1: 170.94,
  y1: 380.36,
  x2: 170.94,
  y2: 350.09,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "fbadd24b-c03d-437f-bbb8-4d8b289ce3da",
  x1: 187.76,
  y1: 408.95,
  x2: 187.76,
  y2: 378.68,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "2d033cbb-f20a-46be-baa8-652f77a00af9",
  x1: 172.62,
  y1: 351.77,
  x2: 172.62,
  y2: 321.49,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "3423a687-c1fa-4574-8890-e009c1c8d223",
  x1: 175.99,
  y1: 366.91,
  x2: 175.99,
  y2: 336.63,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "aed7bf24-752c-4d72-bb46-8eee374d80ce",
  x1: 193.93,
  y1: 377,
  x2: 193.93,
  y2: 346.72,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "74b2a53a-bb8d-4817-af0f-547fba41d21c",
  x1: 212.43,
  y1: 374.19,
  x2: 212.43,
  y2: 343.92,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "8b75dab9-0f62-4d02-bfac-491ded2e8f2f",
  x1: 207.38,
  y1: 389.33,
  x2: 207.38,
  y2: 359.06,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "d7f4ebc6-3fcc-4c72-a8ed-0cc210982a88",
  x1: 144.03,
  y1: 369.71,
  x2: 144.03,
  y2: 339.44,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "6c583912-91b6-4898-86fb-e2ec9a4e0915",
  x1: 100.3,
  y1: 415.68,
  x2: 100.3,
  y2: 385.41,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "57016bda-f426-4e23-aab0-98541199fe77",
  x1: 126.65,
  y1: 390.45,
  x2: 126.65,
  y2: 360.18,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "45131267-4006-4d03-89e8-6cf31dacf3a7",
  x1: 72.83,
  y1: 433.62,
  x2: 72.83,
  y2: 403.35,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "654e43e5-b13a-4b15-8a9f-95a325fe6551",
  x1: 218.04,
  y1: 421.85,
  x2: 218.04,
  y2: 391.57,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "5100e24e-f82a-4c67-8efd-1fb0621d1452",
  x1: 150.2,
  y1: 336.63,
  x2: 150.2,
  y2: 306.36,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "98eaa204-732d-48bb-8eba-68176b6cb80d",
  x1: 122.73,
  y1: 371.39,
  x2: 122.73,
  y2: 341.12,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "47bc87d9-d95f-4520-8d49-0141d8e84b1f",
  x1: 100.86,
  y1: 397.18,
  x2: 100.86,
  y2: 366.91,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "ad8ea935-4f51-4121-a461-22ce9308a26b",
  x1: 116.56,
  y1: 425.77,
  x2: 116.56,
  y2: 395.5,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "4b3fdb4f-0fba-4558-ae10-fa0899fde927",
  x1: 137.86,
  y1: 406.71,
  x2: 137.86,
  y2: 376.44,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "9c82f46e-67f9-4854-a913-e80fd40b4505",
  x1: 149.08,
  y1: 425.77,
  x2: 149.08,
  y2: 395.5,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "94b4005c-0a99-4511-8f26-3ae56047de0a",
  x1: 265.13,
  y1: 442.59,
  x2: 265.13,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "b0fffae2-bb48-43ea-8ac9-db11dbc5ea9d",
  x1: 243.82,
  y1: 439.23,
  x2: 243.82,
  y2: 408.95,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "cf6dd8e8-cefc-4e0a-9d9b-373f21e110d7",
  x1: 202.9,
  y1: 440.91,
  x2: 202.9,
  y2: 410.64,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "6678c91d-2717-425d-bef9-c555f736cbe7",
  x1: 157.49,
  y1: 442.59,
  x2: 157.49,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "5297df59-5499-4111-a486-7e1a06cfabac",
  x1: 153,
  y1: 382.04,
  x2: 153,
  y2: 351.77,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "059442aa-5aeb-41b7-ba5d-abf1ca3bc974",
  x1: 168.14,
  y1: 401.11,
  x2: 168.14,
  y2: 370.83,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "3d4d63e0-fb61-411a-91fb-e2ee16a6c4e8",
  x1: 142.91,
  y1: 354.57,
  x2: 142.91,
  y2: 324.3,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "7c9762fe-252f-458c-96ed-c5fe01f53e6d",
  x1: 159.73,
  y1: 356.25,
  x2: 159.73,
  y2: 325.98,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "e399a398-50f6-464e-a885-e2a5124368b6",
  x1: 187.76,
  y1: 364.1,
  x2: 187.76,
  y2: 333.83,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "94c95248-6c1c-459f-b349-9d8070fcbbf6",
  x1: 112.07,
  y1: 388.77,
  x2: 112.07,
  y2: 358.5,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "be7c7a75-c839-44e3-bb95-11462ca995f7",
  x1: 122.73,
  y1: 408.39,
  x2: 122.73,
  y2: 378.12,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "1c025a95-16c1-47b2-af84-f4fd4588f3a8",
  x1: 130.02,
  y1: 431.38,
  x2: 130.02,
  y2: 401.11,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "658db19d-e937-4a58-9320-b67d9fa7c9d4",
  x1: 172.62,
  y1: 424.09,
  x2: 172.62,
  y2: 393.82,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "0245e264-ac34-4cd8-966e-2281cb490f4d",
  x1: 216.35,
  y1: 410.64,
  x2: 216.35,
  y2: 380.36,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "a8f660ac-f157-41d9-8717-6af001822d1a",
  x1: 230.37,
  y1: 398.86,
  x2: 230.37,
  y2: 368.59,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "2cdabf00-84c0-4b21-a27b-03dfa6b06df6",
  x1: 252.23,
  y1: 425.77,
  x2: 252.23,
  y2: 395.5,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "70d16174-6305-4c7a-b913-022da8e4a220",
  x1: 181.59,
  y1: 444.27,
  x2: 181.59,
  y2: 414,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "9a2bc465-fb6e-45e3-9715-3fb4637fc86b",
  x1: 103.67,
  y1: 437.55,
  x2: 103.67,
  y2: 407.27,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "0b09d010-e7df-434f-9178-cb9e8138f131",
  x1: 81.8,
  y1: 417.92,
  x2: 81.8,
  y2: 387.65,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "f1cdb18a-c771-4917-ac86-fbe766f55ee6",
  x1: 110.39,
  y1: 408.39,
  x2: 110.39,
  y2: 378.12,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "3d3bbc5b-4d7c-45e9-b40c-05c49dd87298",
  x1: 94.69,
  y1: 385.41,
  x2: 94.69,
  y2: 355.13,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "50d3cbe8-c642-4d06-9147-8b3a8a66b0b8",
  x1: 108.15,
  y1: 364.1,
  x2: 108.15,
  y2: 333.83,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "68b00927-fbaa-4146-b5b0-462ab386aad4",
  x1: 225.32,
  y1: 442.59,
  x2: 225.32,
  y2: 412.32,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "0f076225-1862-4162-b858-1281b651f875",
  x1: 162.81,
  y1: 677.5,
  x2: 162.81,
  y2: 427.46,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "abf7e6f2-bcd0-4405-8985-f1e62f4c1e4c",
  x1: 86.85,
  y1: 401.11,
  x2: 86.85,
  y2: 370.83,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "d54eb898-f786-4f85-9a48-33b963b5d8b8",
  x1: 124.97,
  y1: 358.5,
  x2: 124.97,
  y2: 328.22,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "96aa09be-8ec1-4566-95c8-ce78961e7eb1",
  x1: 71.71,
  y1: 424.09,
  x2: 71.71,
  y2: 393.82,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "4ab383be-6c91-44a3-82ed-3e1940113dba",
  x1: 53.57,
  y1: 321.26,
  x2: 53.57,
  y2: 290.98,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "b114d039-19d3-4273-96cd-721b3ffa56ca",
  x1: 979.26,
  y1: 510.07,
  x2: 979.26,
  y2: 351.98,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("clipPath", {
  id: "a19b45cf-fcb4-4c03-9939-acced4c0c67e",
  transform: "translate(-152.12 -100.85)"
}, React.createElement("path", {
  id: "57881ca8-e7c9-455e-98a0-adebd859a564",
  "data-name": "<Clipping Path>",
  d: "M1031.12,373.43l-6.77-16.49L934.08,394a11.15,11.15,0,0,0-6.91,10.31v97.53H945V408.81Z",
  fill: "#f2f2f2"
})), React.createElement("linearGradient", {
  id: "d0c5ed15-51fe-4852-891e-b0305d57f60c",
  x1: 787.61,
  y1: 694.3,
  x2: 787.61,
  y2: 384,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "73a4f828-edd2-4e48-97bd-9bcb305196f0",
  x1: 787.2,
  y1: 576.01,
  x2: 787.2,
  y2: 477.17,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 0.55,
  stopOpacity: 0.09
}), React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.02
})), React.createElement("linearGradient", {
  id: "a8b03343-4c5a-4436-8864-65c423c59246",
  x1: 117.26,
  y1: 234.51,
  x2: 117.26,
  y2: 204.24,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "69c2fe58-062f-467b-afb9-81a24de72d6c",
  x1: 172.16,
  y1: 168.63,
  x2: 172.16,
  y2: 138.35,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "11536ec6-4cc6-47e7-92d7-710fd5bff50d",
  x1: 278.67,
  y1: 310.28,
  x2: 278.67,
  y2: 280,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "08e02247-7e66-482b-b68c-8243a28a41b2",
  x1: 363.22,
  y1: 417.89,
  x2: 363.22,
  y2: 387.61,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "c4f8377c-dae5-454f-b3f1-2b316ac317fc",
  x1: 49.18,
  y1: 680.32,
  x2: 49.18,
  y2: 650.05,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "c3564592-807d-4bae-b07e-cd7d41f54c08",
  x1: 28.31,
  y1: 652.87,
  x2: 28.31,
  y2: 622.6,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "02e0d9b2-dd62-4bea-9309-8de5f110771b",
  x1: 15.14,
  y1: 504.63,
  x2: 15.14,
  y2: 474.36,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "15613dbc-00f1-4fe8-8ae5-2fad0c90759c",
  x1: 300.63,
  y1: 668.24,
  x2: 300.63,
  y2: 637.97,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "f931e1d4-9cb1-419c-ad36-53d7f8c99488",
  x1: 328.08,
  y1: 650.68,
  x2: 328.08,
  y2: 620.4,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "80cee248-a86c-4263-9e87-b18be0896754",
  x1: 331.38,
  y1: 671.54,
  x2: 331.38,
  y2: 641.26,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "d6702938-2bc7-4b9e-8a2c-5c8674d68bcc",
  x1: 274.28,
  y1: 671.54,
  x2: 274.28,
  y2: 641.26,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "c3c2f947-8308-4e36-bb02-388a47ed335c",
  x1: 759.61,
  y1: 142.75,
  x2: 759.61,
  y2: 0,
  xlinkHref: "#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2"
}), React.createElement("linearGradient", {
  id: "e103c76e-73c8-428f-b06b-eaa70735fb85",
  x1: 770.44,
  y1: 104.32,
  x2: 770.44,
  y2: 38.43,
  xlinkHref: "#73a4f828-edd2-4e48-97bd-9bcb305196f0"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "movie night");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M578.24,635.33S655.16,798.6,877.68,747.19c0,0-23.55-20.41,0-47.88L691.27,618.07Z",
  transform: "translate(-152.12 -100.85)",
  fill: "url(#3ccf89fc-b235-48c4-a7b3-ec74ccda02b2)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M585.34,637.82s73.27,155.52,285.24,106.54c0,0-22.43-19.44,0-45.61L693,621.37Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#6c63ff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 463.13,
  cy: 375.47,
  r: 178.7,
  fill: "url(#3d0c0a2e-ebd5-4792-8384-d506b1409550)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 463.13,
  cy: 375.47,
  r: 171.23,
  fill: "#6c63ff"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M615.25,213.88c-144.94,0-262.44,117.5-262.44,262.44s117.5,262.44,262.44,262.44,262.44-117.5,262.44-262.44S760.19,213.88,615.25,213.88Zm95.57,137.05A60.8,60.8,0,1,1,688.56,434,60.8,60.8,0,0,1,710.82,350.94ZM519.68,601.7a60.8,60.8,0,1,1,22.25-83.05A60.8,60.8,0,0,1,519.68,601.7ZM541.93,434a60.8,60.8,0,1,1-22.25-83.05A60.8,60.8,0,0,1,541.93,434Zm73.31,248.58a60.8,60.8,0,1,1,60.8-60.8A60.8,60.8,0,0,1,615.25,682.57ZM576.77,473.24a38.48,38.48,0,1,1,38.48,38.48A38.48,38.48,0,0,1,576.77,473.24Zm38.48-81.58a60.8,60.8,0,1,1,60.8-60.8A60.8,60.8,0,0,1,615.25,391.66ZM793.87,579.44a60.8,60.8,0,1,1-22.25-83.05A60.8,60.8,0,0,1,793.87,579.44Z",
  transform: "translate(-152.12 -100.85)",
  fill: "url(#cfc67d4e-9240-408d-ae53-2d0cbcb1d112)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M615.25,221.36c-140.81,0-255,114.15-255,255s114.15,255,255,255,255-114.15,255-255S756.06,221.36,615.25,221.36Zm92.85,133.15a59.07,59.07,0,1,1-21.62,80.69A59.07,59.07,0,0,1,708.09,354.51ZM522.4,598.13A59.07,59.07,0,1,1,544,517.44,59.07,59.07,0,0,1,522.4,598.13ZM544,435.19a59.07,59.07,0,1,1-21.62-80.69A59.07,59.07,0,0,1,544,435.19Zm71.23,241.5a59.07,59.07,0,1,1,59.07-59.07A59.07,59.07,0,0,1,615.25,676.7ZM577.86,473.33a37.38,37.38,0,1,1,37.38,37.38A37.38,37.38,0,0,1,577.86,473.33Zm37.38-79.25A59.07,59.07,0,1,1,674.31,335,59.07,59.07,0,0,1,615.25,394.07ZM788.78,576.51a59.07,59.07,0,1,1-21.62-80.69A59.07,59.07,0,0,1,788.78,576.51Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#e6e6e6"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M377.49,491.27c0-140.81,114.15-255,255-255a253.79,253.79,0,0,1,148.18,47.47,253.93,253.93,0,0,0-165.38-60.93c-140.81,0-255,114.15-255,255A254.63,254.63,0,0,0,467.07,685.3,254.38,254.38,0,0,1,377.49,491.27Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 463.13,
  cy: 372.47,
  r: 42.99,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 13,
  opacity: 0.2
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 137.3,
  cy: 427.46,
  r: 15.14,
  fill: "url(#55618a58-b994-4cf3-bc33-e350414592a2)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 137.3,
  cy: 427.46,
  r: 13.46,
  fill: "#fdd835"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M279.33,532.23a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,280.61,538,13.4,13.4,0,0,1,279.33,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref15 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 181.03,
  cy: 427.46,
  r: 15.14,
  fill: "url(#a62bac33-b4e8-4f63-988d-f7345c8676e6)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 181.03,
  cy: 427.46,
  r: 13.46,
  fill: "#fdd835"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M323.06,532.23a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,324.34,538,13.4,13.4,0,0,1,323.06,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref18 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 56.57,
  cy: 427.46,
  r: 15.14,
  fill: "url(#01b0c20f-63c0-4fa3-acca-bb5f9cdc7d47)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 56.57,
  cy: 427.46,
  r: 13.46,
  fill: "#fdd835"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.6,532.23a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,199.87,538,13.4,13.4,0,0,1,198.6,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 113.76,
  cy: 389.33,
  r: 15.14,
  fill: "url(#e792799f-2a16-4b5c-8db0-cb1aa0d2a23d)"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 113.76,
  cy: 389.33,
  r: 13.46,
  fill: "#fdd835"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M255.78,494.11a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,255.78,494.11Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref24 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 202.9,
  cy: 395.5,
  r: 15.14,
  fill: "url(#4900b58d-8dde-4024-9730-e3dd5ba623cc)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 202.9,
  cy: 395.5,
  r: 13.46,
  fill: "#fdd835"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.92,500.28a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,346.2,506,13.4,13.4,0,0,1,344.92,500.28Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref27 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 181.03,
  cy: 382.04,
  r: 15.14,
  fill: "url(#8c5be7c8-2b17-4a1f-8c6e-c3983b864ee6)"
});

var _ref28 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 181.03,
  cy: 382.04,
  r: 13.46,
  fill: "#fdd835"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M323.06,486.82a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,323.06,486.82Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref30 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 191.69,
  cy: 414,
  r: 15.14,
  fill: "url(#d5b7eefc-9f3e-4b39-92f9-ccf9139cee39)"
});

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 191.69,
  cy: 414,
  r: 13.46,
  fill: "#fdd835"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M333.71,518.78a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,335,524.5,13.4,13.4,0,0,1,333.71,518.78Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref33 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 152.44,
  cy: 389.33,
  r: 15.14,
  fill: "url(#c31766a7-9c9c-44b4-8ede-5888174e1f8a)"
});

var _ref34 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 152.44,
  cy: 389.33,
  r: 13.46,
  fill: "#fdd835"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M294.47,494.11a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,294.47,494.11Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref36 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 150.76,
  cy: 346.72,
  r: 15.14,
  fill: "url(#4348c26f-db85-4738-947f-fb5f7cbdce4b)"
});

var _ref37 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 150.76,
  cy: 346.72,
  r: 13.46,
  fill: "#fdd835"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.79,451.5a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,292.79,451.5Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref39 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 225.32,
  cy: 368.59,
  r: 15.14,
  fill: "url(#66a2fc62-0231-470f-8d66-10fd6d934ae3)"
});

var _ref40 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 225.32,
  cy: 368.59,
  r: 13.46,
  fill: "#fdd835"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M367.35,473.36a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,367.35,473.36Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref42 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 218.04,
  cy: 397.18,
  r: 15.14,
  fill: "url(#da71f962-9307-4dc4-b5fe-1d8a8f7784ac)"
});

var _ref43 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 218.04,
  cy: 397.18,
  r: 13.46,
  fill: "#fdd835"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M360.06,502a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,360.06,502Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref45 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 251.67,
  cy: 391.57,
  r: 15.14,
  fill: "url(#1ef09f19-b93e-4b1d-bf2c-735162991b2b)"
});

var _ref46 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 251.67,
  cy: 391.57,
  r: 13.46,
  fill: "#fdd835"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M393.7,496.35a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,395,502.07,13.4,13.4,0,0,1,393.7,496.35Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref48 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 236.54,
  cy: 405.59,
  r: 15.14,
  fill: "url(#5c1ea6b8-5bc0-4af9-a2e3-6a873526abd3)"
});

var _ref49 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 236.54,
  cy: 405.59,
  r: 13.46,
  fill: "#fdd835"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M378.56,510.37a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,378.56,510.37Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref51 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 135.62,
  cy: 368.59,
  r: 15.14,
  fill: "url(#30840ded-278f-4d73-abee-5ec61025ef00)"
});

var _ref52 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 135.62,
  cy: 368.59,
  r: 13.46,
  fill: "#fdd835"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M277.65,473.36a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,277.65,473.36Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref54 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 113.76,
  cy: 425.77,
  r: 15.14,
  fill: "url(#640daeec-fe0d-4cc5-bfb0-7d2502bda475)"
});

var _ref55 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 113.76,
  cy: 425.77,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M255.78,530.55a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,255.78,530.55Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref57 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 79.56,
  cy: 427.46,
  r: 15.14,
  fill: "url(#9ac0ede8-18c8-48c9-b5a7-91d4c442db44)"
});

var _ref58 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 79.56,
  cy: 427.46,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M221.58,532.23a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,222.86,538,13.4,13.4,0,0,1,221.58,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref60 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 96.94,
  cy: 417.92,
  r: 15.14,
  fill: "url(#9b6ad9db-95ba-4532-a5ad-4f7024867a5b)"
});

var _ref61 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 96.94,
  cy: 417.92,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M239,522.7a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,239,522.7Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref63 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 170.94,
  cy: 401.11,
  r: 15.14,
  fill: "url(#8d86ace4-e95e-473e-bb5a-5a267cbf00d9)"
});

var _ref64 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 170.94,
  cy: 401.11,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M313,505.88a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,313,505.88Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref66 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 170.94,
  cy: 365.22,
  r: 15.14,
  fill: "url(#90785fb7-aff9-4894-accc-b6020db5a58e)"
});

var _ref67 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 170.94,
  cy: 365.22,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M313,470a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,313,470Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref69 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 187.76,
  cy: 393.82,
  r: 15.14,
  fill: "url(#fbadd24b-c03d-437f-bbb8-4d8b289ce3da)"
});

var _ref70 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 187.76,
  cy: 393.82,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M329.79,498.59a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,329.79,498.59Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref72 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 172.62,
  cy: 336.63,
  r: 15.14,
  fill: "url(#2d033cbb-f20a-46be-baa8-652f77a00af9)"
});

var _ref73 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 172.62,
  cy: 336.63,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M314.65,441.41a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,314.65,441.41Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref75 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 175.99,
  cy: 351.77,
  r: 15.14,
  fill: "url(#3423a687-c1fa-4574-8890-e009c1c8d223)"
});

var _ref76 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 175.99,
  cy: 351.77,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M318,456.55a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,318,456.55Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref78 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 193.93,
  cy: 361.86,
  r: 15.14,
  fill: "url(#aed7bf24-752c-4d72-bb46-8eee374d80ce)"
});

var _ref79 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 193.93,
  cy: 361.86,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M336,466.64A13.45,13.45,0,0,1,358.79,457a13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,336,466.64Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref81 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 212.43,
  cy: 359.06,
  r: 15.14,
  fill: "url(#74b2a53a-bb8d-4817-af0f-547fba41d21c)"
});

var _ref82 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 212.43,
  cy: 359.06,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M354.46,463.83a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,354.46,463.83Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref84 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 207.38,
  cy: 374.19,
  r: 15.14,
  fill: "url(#8b75dab9-0f62-4d02-bfac-491ded2e8f2f)"
});

var _ref85 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 207.38,
  cy: 374.19,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M349.41,479a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,349.41,479Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref87 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 144.03,
  cy: 354.57,
  r: 15.14,
  fill: "url(#d7f4ebc6-3fcc-4c72-a8ed-0cc210982a88)"
});

var _ref88 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 144.03,
  cy: 354.57,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M286.06,459.35a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,286.06,459.35Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref90 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 100.3,
  cy: 400.54,
  r: 15.14,
  fill: "url(#6c583912-91b6-4898-86fb-e2ec9a4e0915)"
});

var _ref91 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 100.3,
  cy: 400.54,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M242.33,505.32a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,243.6,511,13.4,13.4,0,0,1,242.33,505.32Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref93 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 126.65,
  cy: 375.32,
  r: 15.14,
  fill: "url(#57016bda-f426-4e23-aab0-98541199fe77)"
});

var _ref94 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 126.65,
  cy: 375.32,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M268.68,480.09a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,270,485.81,13.4,13.4,0,0,1,268.68,480.09Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref96 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 72.83,
  cy: 418.49,
  r: 15.14,
  fill: "url(#45131267-4006-4d03-89e8-6cf31dacf3a7)"
});

var _ref97 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 72.83,
  cy: 418.49,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M214.86,523.26a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,216.13,529,13.4,13.4,0,0,1,214.86,523.26Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref99 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 218.04,
  cy: 406.71,
  r: 15.14,
  fill: "url(#654e43e5-b13a-4b15-8a9f-95a325fe6551)"
});

var _ref100 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 218.04,
  cy: 406.71,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M360.06,511.49a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,360.06,511.49Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref102 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 150.2,
  cy: 321.49,
  r: 15.14,
  fill: "url(#5100e24e-f82a-4c67-8efd-1fb0621d1452)"
});

var _ref103 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 150.2,
  cy: 321.49,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.22,426.27a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,293.5,432,13.4,13.4,0,0,1,292.22,426.27Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref105 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 122.73,
  cy: 356.25,
  r: 15.14,
  fill: "url(#98eaa204-732d-48bb-8eba-68176b6cb80d)"
});

var _ref106 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 122.73,
  cy: 356.25,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M264.75,461a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,266,466.75,13.4,13.4,0,0,1,264.75,461Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref108 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 100.86,
  cy: 382.04,
  r: 15.14,
  fill: "url(#47bc87d9-d95f-4520-8d49-0141d8e84b1f)"
});

var _ref109 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 100.86,
  cy: 382.04,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M242.89,486.82a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,242.89,486.82Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref111 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 116.56,
  cy: 410.64,
  r: 15.14,
  fill: "url(#ad8ea935-4f51-4121-a461-22ce9308a26b)"
});

var _ref112 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 116.56,
  cy: 410.64,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  d: "M258.59,515.41a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,258.59,515.41Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref114 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 137.86,
  cy: 391.57,
  r: 15.14,
  fill: "url(#4b3fdb4f-0fba-4558-ae10-fa0899fde927)"
});

var _ref115 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 137.86,
  cy: 391.57,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  d: "M279.89,496.35a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,279.89,496.35Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref117 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 149.08,
  cy: 410.64,
  r: 15.14,
  fill: "url(#9c82f46e-67f9-4854-a913-e80fd40b4505)"
});

var _ref118 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 149.08,
  cy: 410.64,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  d: "M291.1,515.41a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,291.1,515.41Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref120 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 265.13,
  cy: 427.46,
  r: 15.14,
  fill: "url(#94b4005c-0a99-4511-8f26-3ae56047de0a)"
});

var _ref121 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 265.13,
  cy: 427.46,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M407.16,532.23A13.45,13.45,0,0,1,430,522.59,13.45,13.45,0,1,0,408.43,538,13.4,13.4,0,0,1,407.16,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref123 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 243.82,
  cy: 424.09,
  r: 15.14,
  fill: "url(#b0fffae2-bb48-43ea-8ac9-db11dbc5ea9d)"
});

var _ref124 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 243.82,
  cy: 424.09,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M385.85,528.87a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,385.85,528.87Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref126 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 202.9,
  cy: 425.77,
  r: 15.14,
  fill: "url(#cf6dd8e8-cefc-4e0a-9d9b-373f21e110d7)"
});

var _ref127 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 202.9,
  cy: 425.77,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref128 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 205.7,
  cy: 410.08,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.92,530.55a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,344.92,530.55Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref130 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 157.49,
  cy: 427.46,
  r: 15.14,
  fill: "url(#6678c91d-2717-425d-bef9-c555f736cbe7)"
});

var _ref131 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 157.49,
  cy: 427.46,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref132 =
/*#__PURE__*/
React.createElement("path", {
  d: "M299.51,532.23a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,300.79,538,13.4,13.4,0,0,1,299.51,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref133 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 153,
  cy: 366.91,
  r: 15.14,
  fill: "url(#5297df59-5499-4111-a486-7e1a06cfabac)"
});

var _ref134 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 153,
  cy: 366.91,
  r: 13.46,
  fill: "#fdd835"
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  d: "M295,471.68A13.45,13.45,0,0,1,317.86,462a13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,295,471.68Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref136 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 168.14,
  cy: 385.97,
  r: 15.14,
  fill: "url(#059442aa-5aeb-41b7-ba5d-abf1ca3bc974)"
});

var _ref137 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 168.14,
  cy: 385.97,
  r: 13.46,
  fill: "#fdd835"
});

var _ref138 =
/*#__PURE__*/
React.createElement("path", {
  d: "M310.16,490.74A13.45,13.45,0,0,1,333,481.1a13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,310.16,490.74Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref139 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 142.91,
  cy: 339.44,
  r: 15.14,
  fill: "url(#3d4d63e0-fb61-411a-91fb-e2ee16a6c4e8)"
});

var _ref140 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 142.91,
  cy: 339.44,
  r: 13.46,
  fill: "#fdd835"
});

var _ref141 =
/*#__PURE__*/
React.createElement("path", {
  d: "M284.94,444.21a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,284.94,444.21Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref142 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 159.73,
  cy: 341.12,
  r: 15.14,
  fill: "url(#7c9762fe-252f-458c-96ed-c5fe01f53e6d)"
});

var _ref143 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 159.73,
  cy: 341.12,
  r: 13.46,
  fill: "#fdd835"
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  d: "M301.76,445.89a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,303,451.62,13.4,13.4,0,0,1,301.76,445.89Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref145 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 187.76,
  cy: 348.97,
  r: 15.14,
  fill: "url(#e399a398-50f6-464e-a885-e2a5124368b6)"
});

var _ref146 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 187.76,
  cy: 348.97,
  r: 13.46,
  fill: "#fdd835"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  d: "M329.79,453.74a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,329.79,453.74Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref148 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 112.07,
  cy: 373.63,
  r: 15.14,
  fill: "url(#94c95248-6c1c-459f-b349-9d8070fcbbf6)"
});

var _ref149 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 112.07,
  cy: 373.63,
  r: 13.46,
  fill: "#fdd835"
});

var _ref150 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.1,478.41a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,254.1,478.41Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref151 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 122.73,
  cy: 393.26,
  r: 15.14,
  fill: "url(#be7c7a75-c839-44e3-bb95-11462ca995f7)"
});

var _ref152 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 122.73,
  cy: 393.26,
  r: 13.46,
  fill: "#fdd835"
});

var _ref153 =
/*#__PURE__*/
React.createElement("path", {
  d: "M264.75,498a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,266,503.76,13.4,13.4,0,0,1,264.75,498Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref154 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 130.02,
  cy: 416.24,
  r: 15.14,
  fill: "url(#1c025a95-16c1-47b2-af84-f4fd4588f3a8)"
});

var _ref155 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 130.02,
  cy: 416.24,
  r: 13.46,
  fill: "#fdd835"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M272,521a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,272,521Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref157 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 172.62,
  cy: 408.95,
  r: 15.14,
  fill: "url(#658db19d-e937-4a58-9320-b67d9fa7c9d4)"
});

var _ref158 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 172.62,
  cy: 408.95,
  r: 13.46,
  fill: "#fdd835"
});

var _ref159 =
/*#__PURE__*/
React.createElement("path", {
  d: "M314.65,513.73a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,314.65,513.73Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref160 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 216.35,
  cy: 395.5,
  r: 15.14,
  fill: "url(#0245e264-ac34-4cd8-966e-2281cb490f4d)"
});

var _ref161 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 216.35,
  cy: 395.5,
  r: 13.46,
  fill: "#fdd835"
});

var _ref162 =
/*#__PURE__*/
React.createElement("path", {
  d: "M358.38,500.28a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,359.66,506,13.4,13.4,0,0,1,358.38,500.28Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref163 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 230.37,
  cy: 383.73,
  r: 15.14,
  fill: "url(#a8f660ac-f157-41d9-8717-6af001822d1a)"
});

var _ref164 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 230.37,
  cy: 383.73,
  r: 13.46,
  fill: "#fdd835"
});

var _ref165 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 196.17,
  cy: 382.6,
  r: 13.46,
  fill: "#fdd835"
});

var _ref166 =
/*#__PURE__*/
React.createElement("path", {
  d: "M372.4,488.5a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,372.4,488.5Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref167 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 252.23,
  cy: 410.64,
  r: 15.14,
  fill: "url(#2cdabf00-84c0-4b21-a27b-03dfa6b06df6)"
});

var _ref168 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 252.23,
  cy: 410.64,
  r: 13.46,
  fill: "#fdd835"
});

var _ref169 =
/*#__PURE__*/
React.createElement("path", {
  d: "M394.26,515.41a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,394.26,515.41Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref170 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 181.59,
  cy: 429.14,
  r: 15.14,
  fill: "url(#70d16174-6305-4c7a-b913-022da8e4a220)"
});

var _ref171 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 181.59,
  cy: 429.14,
  r: 13.46,
  fill: "#fdd835"
});

var _ref172 =
/*#__PURE__*/
React.createElement("path", {
  d: "M323.62,533.91a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,323.62,533.91Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref173 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 103.67,
  cy: 422.41,
  r: 15.14,
  fill: "url(#9a2bc465-fb6e-45e3-9715-3fb4637fc86b)"
});

var _ref174 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 103.67,
  cy: 422.41,
  r: 13.46,
  fill: "#fdd835"
});

var _ref175 =
/*#__PURE__*/
React.createElement("path", {
  d: "M245.69,527.19a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,247,532.91,13.4,13.4,0,0,1,245.69,527.19Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref176 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 81.8,
  cy: 402.79,
  r: 15.14,
  fill: "url(#0b09d010-e7df-434f-9178-cb9e8138f131)"
});

var _ref177 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 81.8,
  cy: 402.79,
  r: 13.46,
  fill: "#fdd835"
});

var _ref178 =
/*#__PURE__*/
React.createElement("path", {
  d: "M223.83,507.56a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,223.83,507.56Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref179 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 110.39,
  cy: 393.26,
  r: 15.14,
  fill: "url(#f1cdb18a-c771-4917-ac86-fbe766f55ee6)"
});

var _ref180 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 110.39,
  cy: 393.26,
  r: 13.46,
  fill: "#fdd835"
});

var _ref181 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252.42,498a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,252.42,498Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref182 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 94.69,
  cy: 370.27,
  r: 15.14,
  fill: "url(#3d3bbc5b-4d7c-45e9-b40c-05c49dd87298)"
});

var _ref183 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 94.69,
  cy: 370.27,
  r: 13.46,
  fill: "#fdd835"
});

var _ref184 =
/*#__PURE__*/
React.createElement("path", {
  d: "M236.72,475a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,238,480.77,13.4,13.4,0,0,1,236.72,475Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref185 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 108.15,
  cy: 348.97,
  r: 15.14,
  fill: "url(#50d3cbe8-c642-4d06-9147-8b3a8a66b0b8)"
});

var _ref186 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 108.15,
  cy: 348.97,
  r: 13.46,
  fill: "#fdd835"
});

var _ref187 =
/*#__PURE__*/
React.createElement("path", {
  d: "M250.18,453.74A13.45,13.45,0,0,1,273,444.1a13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,250.18,453.74Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref188 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 225.32,
  cy: 427.46,
  r: 15.14,
  fill: "url(#68b00927-fbaa-4146-b5b0-462ab386aad4)"
});

var _ref189 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 225.32,
  cy: 427.46,
  r: 13.46,
  fill: "#fdd835"
});

var _ref190 =
/*#__PURE__*/
React.createElement("path", {
  d: "M367.35,532.23a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,368.63,538,13.4,13.4,0,0,1,367.35,532.23Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref191 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "246.22 677.5 78.82 677.5 36.39 427.45 289.24 427.45 246.22 677.5",
  fill: "url(#0f076225-1862-4162-b858-1281b651f875)"
});

var _ref192 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "243.82 674.14 82.36 674.14 41.43 431.38 285.31 431.38 243.82 674.14",
  fill: "#fff"
});

var _ref193 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "41.43 431.38 82.92 431.38 122.17 674.14 81.8 674.14 41.43 431.38",
  fill: "#6c63ff"
});

var _ref194 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "285.31 431.38 243.26 431.38 202.9 674.14 243.82 674.14 285.31 431.38",
  fill: "#6c63ff"
});

var _ref195 =
/*#__PURE__*/
React.createElement("rect", {
  x: 142.35,
  y: 431.38,
  width: 40.37,
  height: 242.76,
  fill: "#6c63ff"
});

var _ref196 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 86.85,
  cy: 385.97,
  r: 15.14,
  fill: "url(#abf7e6f2-bcd0-4405-8985-f1e62f4c1e4c)"
});

var _ref197 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 86.85,
  cy: 385.97,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref198 =
/*#__PURE__*/
React.createElement("path", {
  d: "M228.87,490.74a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,228.87,490.74Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref199 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 124.97,
  cy: 343.36,
  r: 15.14,
  fill: "url(#d54eb898-f786-4f85-9a48-33b963b5d8b8)"
});

var _ref200 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 124.97,
  cy: 343.36,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref201 =
/*#__PURE__*/
React.createElement("path", {
  d: "M267,448.14a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,267,448.14Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref202 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 71.71,
  cy: 408.95,
  r: 15.14,
  fill: "url(#96aa09be-8ec1-4566-95c8-ce78961e7eb1)"
});

var _ref203 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 71.71,
  cy: 408.95,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref204 =
/*#__PURE__*/
React.createElement("path", {
  d: "M213.73,513.73a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,215,519.45,13.4,13.4,0,0,1,213.73,513.73Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref205 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 53.57,
  cy: 306.12,
  r: 15.14,
  fill: "url(#4ab383be-6c91-44a3-82ed-3e1940113dba)"
});

var _ref206 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 53.57,
  cy: 306.12,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref207 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.6,410.9a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,195.6,410.9Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref208 =
/*#__PURE__*/
React.createElement("g", {
  id: "d4a79658-ee59-416f-a379-a492ff752217",
  "data-name": "<Group>"
}, React.createElement("path", {
  d: "M1035.73,373.86l-9.1-21.87L930.18,391.6a11.91,11.91,0,0,0-7.38,11V506.83l27.87,3.24V410.64Z",
  transform: "translate(-152.12 -100.85)",
  fill: "url(#b114d039-19d3-4273-96cd-721b3ffa56ca)"
}));

var _ref209 =
/*#__PURE__*/
React.createElement("path", {
  id: "2572ddba-42e8-4159-9036-35cbff74dfb7",
  "data-name": "<Clipping Path>",
  d: "M1031.12,373.43l-6.77-16.49L934.08,394a11.15,11.15,0,0,0-6.91,10.31v97.53H945V408.81Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#f2f2f2"
});

var _ref210 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#a19b45cf-fcb4-4c03-9939-acced4c0c67e)"
}, React.createElement("rect", {
  x: 847.96,
  y: 238.17,
  width: 19.44,
  height: 61.57,
  fill: "#6c63ff"
}), React.createElement("rect", {
  x: 817.18,
  y: 251.13,
  width: 19.44,
  height: 61.57,
  fill: "#6c63ff"
}), React.createElement("polygon", {
  points: "806.64 303.79 792.87 307.84 787.2 242.22 806.64 242.22 806.64 303.79",
  fill: "#6c63ff"
}), React.createElement("rect", {
  x: 929.6,
  y: 390.87,
  width: 19.44,
  height: 61.57,
  transform: "translate(365.54 1260.12) rotate(-90)",
  fill: "#6c63ff"
}), React.createElement("rect", {
  x: 929.6,
  y: 417.61,
  width: 19.44,
  height: 61.57,
  transform: "translate(338.81 1286.86) rotate(-90)",
  fill: "#6c63ff"
}), React.createElement("rect", {
  x: 929.6,
  y: 444.34,
  width: 19.44,
  height: 61.57,
  transform: "translate(312.07 1313.6) rotate(-90)",
  fill: "#6c63ff"
}));

var _ref211 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "895.76 384 679.45 384 679.45 418.12 694.22 418.12 724.29 694.3 853.56 694.3 880.29 416.5 895.76 416.5 895.76 384",
  fill: "url(#d0c5ed15-51fe-4852-891e-b0305d57f60c)"
});

var _ref212 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "847.96 688.63 728.87 688.63 699.7 396.96 873.89 396.96 847.96 688.63",
  fill: "#6c63ff"
});

var _ref213 =
/*#__PURE__*/
React.createElement("rect", {
  x: 687.55,
  y: 392.1,
  width: 199.3,
  height: 19.44,
  fill: "#6c63ff"
});

var _ref214 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 787.2,
  cy: 526.59,
  r: 49.42,
  fill: "url(#73a4f828-edd2-4e48-97bd-9bcb305196f0)"
});

var _ref215 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 787.2,
  cy: 526.59,
  r: 45.37,
  fill: "#fff"
});

var _ref216 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 117.26,
  cy: 219.38,
  r: 15.14,
  fill: "url(#a8b03343-4c5a-4436-8864-65c423c59246)"
});

var _ref217 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 117.26,
  cy: 219.38,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref218 =
/*#__PURE__*/
React.createElement("path", {
  d: "M259.28,324.15a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,259.28,324.15Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref219 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 172.16,
  cy: 153.49,
  r: 15.14,
  fill: "url(#69c2fe58-062f-467b-afb9-81a24de72d6c)"
});

var _ref220 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 172.16,
  cy: 153.49,
  r: 13.46,
  fill: "#fdd835"
});

var _ref221 =
/*#__PURE__*/
React.createElement("path", {
  d: "M314.19,258.27A13.45,13.45,0,0,1,337,248.62,13.45,13.45,0,1,0,315.46,264,13.4,13.4,0,0,1,314.19,258.27Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref222 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 278.67,
  cy: 295.14,
  r: 15.14,
  fill: "url(#11536ec6-4cc6-47e7-92d7-710fd5bff50d)"
});

var _ref223 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 278.67,
  cy: 295.14,
  r: 13.46,
  fill: "#fdd835"
});

var _ref224 =
/*#__PURE__*/
React.createElement("path", {
  d: "M420.7,399.92a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,422,405.64,13.4,13.4,0,0,1,420.7,399.92Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref225 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 363.22,
  cy: 402.75,
  r: 15.14,
  fill: "url(#08e02247-7e66-482b-b68c-8243a28a41b2)"
});

var _ref226 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 363.22,
  cy: 402.75,
  r: 13.46,
  fill: "#fdd835"
});

var _ref227 =
/*#__PURE__*/
React.createElement("path", {
  d: "M505.25,507.53a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,505.25,507.53Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref228 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 49.18,
  cy: 665.19,
  r: 15.14,
  fill: "url(#c4f8377c-dae5-454f-b3f1-2b316ac317fc)"
});

var _ref229 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 49.18,
  cy: 665.19,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref230 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.2,770A13.45,13.45,0,0,1,214,760.32a13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,191.2,770Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref231 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 28.31,
  cy: 637.73,
  r: 15.14,
  fill: "url(#c3564592-807d-4bae-b07e-cd7d41f54c08)"
});

var _ref232 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 28.31,
  cy: 637.73,
  r: 13.46,
  fill: "#fdd835"
});

var _ref233 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.34,742.51a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,170.34,742.51Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref234 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 15.14,
  cy: 489.5,
  r: 15.14,
  fill: "url(#02e0d9b2-dd62-4bea-9309-8de5f110771b)"
});

var _ref235 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 15.14,
  cy: 489.5,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref236 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157.16,594.27A13.45,13.45,0,0,1,180,584.63,13.45,13.45,0,1,0,158.44,600,13.4,13.4,0,0,1,157.16,594.27Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref237 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 300.63,
  cy: 653.11,
  r: 15.14,
  fill: "url(#15613dbc-00f1-4fe8-8ae5-2fad0c90759c)"
});

var _ref238 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 300.63,
  cy: 653.11,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref239 =
/*#__PURE__*/
React.createElement("path", {
  d: "M442.66,757.88a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,442.66,757.88Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref240 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 328.08,
  cy: 635.54,
  r: 15.14,
  fill: "url(#f931e1d4-9cb1-419c-ad36-53d7f8c99488)"
});

var _ref241 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 328.08,
  cy: 635.54,
  r: 13.46,
  fill: "#fbc02d"
});

var _ref242 =
/*#__PURE__*/
React.createElement("path", {
  d: "M470.11,740.32a13.45,13.45,0,0,1,22.83-9.65A13.45,13.45,0,1,0,471.39,746,13.4,13.4,0,0,1,470.11,740.32Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref243 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 331.38,
  cy: 656.4,
  r: 15.14,
  fill: "url(#80cee248-a86c-4263-9e87-b18be0896754)"
});

var _ref244 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 331.38,
  cy: 656.4,
  r: 13.46,
  fill: "#fdd835"
});

var _ref245 =
/*#__PURE__*/
React.createElement("path", {
  d: "M473.4,761.18a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,473.4,761.18Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref246 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 274.28,
  cy: 656.4,
  r: 15.14,
  fill: "url(#d6702938-2bc7-4b9e-8a2c-5c8674d68bcc)"
});

var _ref247 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 274.28,
  cy: 656.4,
  r: 13.46,
  fill: "#fdd835"
});

var _ref248 =
/*#__PURE__*/
React.createElement("path", {
  d: "M416.3,761.18a13.45,13.45,0,0,1,22.83-9.65,13.45,13.45,0,1,0-21.55,15.37A13.4,13.4,0,0,1,416.3,761.18Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var _ref249 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 759.61,
  cy: 71.37,
  r: 71.37,
  fill: "url(#c3c2f947-8308-4e36-bb02-388a47ed335c)"
});

var _ref250 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 759.61,
  cy: 71.37,
  r: 66.98,
  fill: "#3ad29f"
});

var _ref251 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "803.96 71.37 736.92 104.31 736.92 71.37 736.92 38.43 803.96 71.37",
  fill: "url(#e103c76e-73c8-428f-b06b-eaa70735fb85)"
});

var _ref252 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "799.93 71.37 740.94 100.36 740.94 71.37 740.94 42.38 799.93 71.37",
  fill: "#fff"
});

var _ref253 =
/*#__PURE__*/
React.createElement("path", {
  d: "M850.23,179.91a67,67,0,0,1,118.62-42.66,67,67,0,1,0-108.77,77.64A66.66,66.66,0,0,1,850.23,179.91Z",
  transform: "translate(-152.12 -100.85)",
  fill: "#fff",
  opacity: 0.2
});

var SvgUndrawMovieNight93wl = function SvgUndrawMovieNight93wl(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "e1e18c23-21c5-4ba7-8e43-9b52646246a3",
    "data-name": "Layer 1",
    width: 895.76,
    height: 694.3,
    viewBox: "0 0 895.76 694.3",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawMovieNight93wl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_movie_night_93wl.e13a12a2.svg";
export { ForwardRef as ReactComponent };